import { ConnectedAccountFundsStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const ConnectedAccountFundsStatusMapping = {
    [ConnectedAccountFundsStatus.Done]: 'success',
    [ConnectedAccountFundsStatus.Pending]: 'info',
    [ConnectedAccountFundsStatus.InProgress]: 'secondary',
    [ConnectedAccountFundsStatus.Suspended]: 'error',
    [ConnectedAccountFundsStatus.Failed]: 'error',
    [ConnectedAccountFundsStatus.Blocked]: 'error',
} as { [key in ConnectedAccountFundsStatus]: EnumColor };
